(() => {
  const key = '__cmPhotoHeader';
  if (window[key]) { window[key].scan(); return; }
  const cleanups = new Map();
  let mountedHeader = null;
  const pageType = document.querySelector('script[data-cm-photo-header]')?.dataset.cmPhotoHeader;
  if (pageType !== 'index' && pageType !== 'collection' && pageType !== 'material') return;
  const materialHeroes = [
    {selector:'[data-cm-material-page] > .cm-cg__hero',images:'img',tone:'light',topOnly:true}
  ];
  const photoHeroes = [
    {selector:'.cm-top-main-visual .cm-hero, .cm-autumn__hero',images:'.cm-hero__slide.is-active .cm-hero__image, .cm-autumn__slide.is-active .cm-autumn__image',bounds:'self',tone:'light'},
    {selector:'collection-banner',images:'.content-over-media img',bounds:'.content-over-media'},
    {selector:'.cm-bl__hero',images:'.cm-bl__hero-image img',tone:'light'},
    {selector:'.c-bag-main-visual-new__hero',images:'.c-bag-main-visual-new__slide.is-active [class*="__image"]',bounds:'self'},
    {selector:'.c-bg-hero',images:'.c-bg-hero__media img',tone:'light'},
    {selector:'section.hero',images:'.hero__image-container .hero__image'},
    {selector:'.gm-hero',images:'.gm-hero__media img'}
  ];
  function visible(element) {
    const box = element.getBoundingClientRect();
    const style = getComputedStyle(element);
    return box.width > 0 && box.height > 0 && style.display !== 'none' && style.visibility !== 'hidden';
  }
  function firstSection() {
    const main = document.querySelector('main#main, main#MainContent, main[role="main"], main');
    return main && [...main.children].find(element => element.matches('.shopify-section') && visible(element));
  }
  function readProperty(element, property) {
    return [element.style.getPropertyValue(property), element.style.getPropertyPriority(property)];
  }
  function writeProperty(element, property, saved) {
    if (saved[0]) element.style.setProperty(property, saved[0], saved[1]);
    else element.style.removeProperty(property);
  }
  function mount(root, spec) {
    if (cleanups.has(root)) return;
    
    const header = document.querySelector('.shopify-section--header:has(.c-header)');
    const hero = root.querySelector(spec.selector);
    if (!header || !hero) return;
    const content = header.querySelector('.c-header');
    const surfaces = [header, header.querySelector('height-observer'), content].filter(Boolean);
    const foregrounds = [...header.querySelectorAll('.c-header__hamburger, .header__logo, .c-header__actions > .contents > :not(.header__account-link), .c-header__actions .header__account-link [slot="signed-out-avatar"]')];
    const original = new Map();
    const properties = ['background','background-image','border-bottom-color','box-shadow','filter'];
    [...surfaces,...foregrounds].forEach(element => original.set(element, properties.map(property => [property,readProperty(element,property)])));
    const margin = readProperty(root,'margin-top');
    const initialHeight = readProperty(root,'--cm-photo-header-height');
    let cssOverlapActive = getComputedStyle(root).getPropertyValue('--cm-photo-css-overlap').trim() === '1';
    let baseMargin = cssOverlapActive ? '0px' : getComputedStyle(root).marginTop || '0px';
    let lastWidth = window.innerWidth;
    let frame = 0;
    let offsetActive = false;
    function restoreHeader() {
      original.forEach((values,element) => values.forEach(([property,saved]) => writeProperty(element,property,saved)));
      delete header.dataset.cmPhotoOverlay;
    }
    function clearOffset() {
      writeProperty(root,'margin-top',margin);
      delete root.dataset.cmPhotoHero;
      offsetActive = false;
    }
    function heroPhoto() {
      if (firstSection() !== root) return null;
      return [...hero.querySelectorAll(spec.images)].find(image => {
        if (!visible(image)) return false;
        if (image.tagName === 'IMG') return image.complete && image.naturalWidth > 0;
        return /url\(/i.test(getComputedStyle(image).backgroundImage);
      }) || null;
    }
    function heroTone() {
      const configured = hero.dataset.headerTone || root.dataset.headerTone || spec.tone;
      if (configured === 'light' || configured === 'dark') return configured;
      const text = hero.querySelector('.prose, .c-bag-main-visual-new__content, .hero__title');
      if (!text) return 'light';
      const channels = getComputedStyle(text).color.match(/[\d.]+/g);
      if (!channels || channels.length < 3) return 'light';
      return Number(channels[0])*.299 + Number(channels[1])*.587 + Number(channels[2])*.114 > 150 ? 'light' : 'dark';
    }
    function update() {
      frame = 0;
      const headerBox = header.getBoundingClientRect();
      root.style.setProperty('--cm-photo-header-height',`${headerBox.height}px`);
      let photo = hero;
      {
        if (window.innerWidth !== lastWidth) {
          writeProperty(root,'margin-top',margin);
          baseMargin = getComputedStyle(root).marginTop || '0px';
          lastWidth = window.innerWidth;
          offsetActive = false;
        }
        photo = heroPhoto();
        if (photo && spec.bounds) photo = spec.bounds === 'self' ? hero : hero.querySelector(spec.bounds) || photo;
        const rootBox = root.getBoundingClientRect();
        const photoBox = photo && photo.getBoundingClientRect();
        const contentBox = content.getBoundingClientRect();
        const leadingPhoto = photoBox && Math.abs(photoBox.top-rootBox.top) <= 4;
        const coversHeader = photoBox && photoBox.left <= contentBox.left+4 && photoBox.right >= contentBox.right-4;
        if (!leadingPhoto || !coversHeader || photoBox.height <= headerBox.height+32) {
          clearOffset(); restoreHeader(); return;
        }
        root.dataset.cmPhotoHero = 'true';
        const cssOverlap = getComputedStyle(root).getPropertyValue('--cm-photo-css-overlap').trim() === '1';
        if (cssOverlap) {
          writeProperty(root,'margin-top',margin);
          offsetActive = false;
        } else {
          if (cssOverlapActive) {
            writeProperty(root,'margin-top',margin);
            baseMargin = getComputedStyle(root).marginTop || '0px';
          }
          const nativeOverlap = Math.max(0,-(parseFloat(getComputedStyle(content).marginBottom)||0));
          const offset = Math.max(0,headerBox.height-nativeOverlap);
          root.style.setProperty('margin-top',`calc(${baseMargin} - ${offset}px)`,'important');
          offsetActive = true;
        }
        cssOverlapActive = cssOverlap;
      }
      const photoBox = photo.getBoundingClientRect();
      const drawerOpen = header.querySelector('[open]') || document.querySelector('#sidebar-menu[open], #cart-drawer[open], [id^="c-header-search"][open]');
      const overlap = !drawerOpen && (!spec.topOnly || window.scrollY < headerBox.height) && photoBox.top <= headerBox.top+4 && photoBox.bottom > headerBox.bottom+32;
      if (!overlap) { restoreHeader(); return; }
      header.dataset.cmPhotoOverlay = 'true';
      surfaces.forEach(element => {
        element.style.setProperty('background','transparent','important');
        element.style.setProperty('background-image','none','important');
        element.style.setProperty('border-bottom-color','transparent','important');
        element.style.setProperty('box-shadow','none','important');
      });
      const tone = heroTone();
      foregrounds.forEach(element => {
        if (tone === 'light') element.style.setProperty('filter','brightness(0) invert(1) drop-shadow(0 1px 2px rgba(0,0,0,.25))','important');
        else writeProperty(element,'filter',original.get(element).find(([property])=>property==='filter')[1]);
      });
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(update); }
    const resize = new ResizeObserver(schedule);
    resize.observe(header); resize.observe(hero);
    const changes = new MutationObserver(schedule);
    changes.observe(header,{subtree:true,attributes:true,attributeFilter:['open']});
    document.querySelectorAll('#sidebar-menu, #cart-drawer, [id^="c-header-search"]').forEach(drawer => changes.observe(drawer,{attributes:true,attributeFilter:['open']}));
    changes.observe(hero,{subtree:true,attributes:true,attributeFilter:['class','src','srcset','style','data-header-tone']});
    
    hero.addEventListener('load',schedule,true);
    hero.addEventListener('error',schedule,true);
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',schedule,{passive:true});
    window.addEventListener('load',schedule);
    update();
    root.dataset.cmPhotoManaged = 'true';
    header.dataset.cmPhotoManaged = 'true';
    cleanups.set(root,()=>{
      cancelAnimationFrame(frame); resize.disconnect(); changes.disconnect();
      
      hero.removeEventListener('load',schedule,true);
      hero.removeEventListener('error',schedule,true);
      window.removeEventListener('scroll',schedule);
      window.removeEventListener('resize',schedule);
      window.removeEventListener('load',schedule);
      restoreHeader();
      delete header.dataset.cmPhotoManaged;
      delete root.dataset.cmPhotoManaged;
      if (offsetActive) clearOffset();
      else delete root.dataset.cmPhotoHero;
      writeProperty(root,'--cm-photo-header-height',initialHeight);
      cleanups.delete(root);
    });
  }
  function scan() {
    const currentHeader = document.querySelector('.shopify-section--header:has(.c-header)');
    if (mountedHeader && mountedHeader !== currentHeader) cleanups.forEach(cleanup=>cleanup());
    mountedHeader = currentHeader;
    const first = firstSection();
    cleanups.forEach((cleanup,root)=>{if (root !== first) cleanup();});
    if (!first) return;
    const specs = pageType === 'material' ? materialHeroes : pageType === 'index' ? photoHeroes.slice(0,1) : [...materialHeroes,...photoHeroes.slice(1)];
    const spec = specs.find(item=>first.querySelector(item.selector));
    if (spec) mount(first,spec);
  }
  scan();
  document.addEventListener('shopify:section:load',event=>{
    cleanups.forEach((cleanup,root)=>{if (event.target === root || event.target.contains(root) || root.contains(event.target)) cleanup();});
    scan();
  });
  document.addEventListener('shopify:section:reorder',scan);
  document.addEventListener('shopify:section:unload',event=>{
    if (mountedHeader && (event.target === mountedHeader || event.target.contains(mountedHeader))) {
      cleanups.forEach(cleanup=>cleanup());
      mountedHeader = null;
      return;
    }
    cleanups.forEach((cleanup,root)=>{if (event.target === root || event.target.contains(root)) cleanup();});
  });
  window[key] = {scan};
})();
